'use client';

//* Components
import ServiceContent from '../ServiceContent';

//* Styles
import ServiceTemplateStyle from './style';

const ServiceTemplate = () => {
	return (
		<ServiceTemplateStyle>
			<ServiceContent />
		</ServiceTemplateStyle>
	);
};

export default ServiceTemplate;
